import React from "react";
import "./style.scss";

const ItemCard: React.FC = ({ children }) => {
  return <div className="card">{children}</div>;
};

export default ItemCard;
